define({
    /** Timeout in milliseconds to wait for fonts to load. */
    LOAD_FONTS_TIMEOUT: 3500
});



// WEBPACK FOOTER //
// ./src/shared/util/FontConstants.js